module.exports = __webpack_public_path__ + "static/media/rss.19b28edc.svg";